import { useBaseHook } from './useBaseHook'

export const useUpdate = (API) => {

    const { onApply } = useBaseHook(API)

    const onUpdate = (id, reqbody = {}, action) => onApply("post-operation", { id, ...reqbody }, action)

    return { onUpdate }
}
